module.exports = __webpack_public_path__ + "img/extract_wrong.09a41dd7.png";